import * as XLSX from 'xlsx'

export type ExcelExportColumn<TRow> = {
    header: string
    getValue: (row: TRow, index: number) => string | number
}

export const exportRowsToExcel = <TRow>(
    rows: TRow[],
    columns: ExcelExportColumn<TRow>[],
    filename: string,
    sheetName = 'Данные'
): void => {
    const headers = columns.map(col => col.header)
    const dataRows = rows.map((row, index) => columns.map(col => col.getValue(row, index)))
    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...dataRows])
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName.slice(0, 31))
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' })
    const url = URL.createObjectURL(blob)
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.download = `${filename}_${new Date().toISOString().slice(0, 10)}.xlsx`
    document.body.appendChild(anchor)
    anchor.click()
    document.body.removeChild(anchor)
    URL.revokeObjectURL(url)
}
